import { DashboardTile } from '../shared/types';

const dashboardTileOrder = [
  'executive-hub',
  'persona-insights-frontline-hub',
  'growth-hub',
  'customer-intelligence',
  'pricing-guidance-tools',
  'resources-tools'
];

export const dashboardTiles: DashboardTile[] = [
  {
    id: 'pricing-guidance-tools',
    title: 'Pricing Guidance Tools',
    tags: ['Account Management'],
    description: 'Strategic pricing tools and market analysis to optimize pricing decisions',
    dashboards: [
      {
        name: 'Price Guidance Tool',
        url: 'https://app.powerbi.com/reportEmbed?reportId=cfe7ca3c-77a5-4b7c-ad96-aa79b7671f54&appId=9ee27c38-bc76-4c0c-aa5f-c1aad8c8d8a6&autoAuth=true&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645',
        tags: ['Account Management', 'Sales Specialist', 'Customer Success', 'Product'],
        description: 'The Price Guidance Dashboard provides revenue reps with clear, data-driven pricing recommendations for renewals and new business. Built on pricing analytics and a value-based pricing model, the dashboard delivers consistent guidance across products and deal types, helping reps price confidently, maximize deal value, and clearly justify price increases.'
      }
    ],
    url: 'https://app.powerbi.com/reportEmbed?reportId=40e3ff08-a79c-41bc-a190-64fdce113cf4&appId=f6008346-ee84-48ee-8950-ea62cc80b0f1&autoAuth=true&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645'
  },
  {
    id: 'resources-tools',
    title: 'Resources & Tools',
    tags: ['Account Management', 'Sales Specialist'],
    description: 'Essential resources and tools for sales enablement and revenue operations.',
    dashboards: [
      {
        name: 'Revenue Playbook',
        url: 'https://sphere.spglobal.com/sites/s-p-global-market-intelligence/mi-sales/sales-enablement/SitePageModern/233374/2025-playbook',
        tags: ['Account Management', 'Sales Specialist', 'Customer Success', 'Prospecting'],
        description: 'The centralized home for MI Revenue\'s ways of working — outlining our rules of engagement, role-based processes, performance expectations, and the standards that guide how we operate every day.'
      },
      {
        name: 'Revenue Tools',
        url: 'https://sphere.spglobal.com/sites/s-p-global-market-intelligence/mi-revenue/revenue-enablement/SitePageModern/233385/tools',
        tags: ['Account Management', 'Sales Specialist', 'Customer Success', 'Prospecting'],
        description: 'Your comprehensive reference guide to the tools available to support Sales and Account Management across all stages of the sales cycle.'
      },
      {
        name: 'Revenue Transformation Transition Resources',
        url: 'https://sphere.spglobal.com/sites/s-p-global-market-intelligence/mi-revenue/SitePageModern/480997/revenue-transformation-transition-resources',
        tags: ['Account Management', 'Sales Specialist']
      },
      {
        name: 'Salesforce',
        url: 'https://spglobal.lightning.force.com/lightning/page/home',
        tags: ['Account Management', 'Sales Specialist', 'Customer Success', 'Prospecting']
      }
    ],
    url: 'https://sphere.spglobal.com/sites/s-p-global-market-intelligence/mi-sales/sales-enablement/SitePageModern/233374/2025-playbook'
  },
  {
    id: 'executive-hub',
    title: 'Executive Hub',
    tags: ['Revenue Leaders'],
    dashboards: [
      {
        name: 'MI Performance Center',
        url: 'https://app.powerbi.com/groups/me/apps/89307cc6-2f54-432e-b917-3727b4f3423c/reports/4102cbcb-ca08-4d06-9ed2-1508b7d3d129/a769ad1e0a509ac401b0?experience=power-bi&bookmarkGuid=f138c3b77d6c4721ce32',
        tags: ['Revenue Leaders'],
        description: 'Executive Summary dashboard for RLT + Revenue people managers showing sales performance and related metrics.',
        subDashboards: [
          {
            name: 'RLT Dashboard',
            url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=89307cc6-2f54-432e-b917-3727b4f3423c&reportObjectId=4102cbcb-ca08-4d06-9ed2-1508b7d3d129&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=a769ad1e0a509ac401b0&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
            description: 'Executive dashboard for sales performance, designed to provide Revenue Leadership with a consolidated view of key commercial KPIs, performance trends, and business insights.'
          },
          {
            name: 'Pipeline Deep Dive',
            url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=89307cc6-2f54-432e-b917-3727b4f3423c&reportObjectId=ee9e473f-defd-4482-9a57-0c7b6832005c&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=2e068bcd4188e09d5497&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
            description: 'Provides a comprehensive view of pipeline health, performance, and trends across key sales dimensions. The dashboard supports data-driven decision-making by helping users quickly identify opportunities, risks, and areas requiring attention.'
          },
          {
            name: 'Renewal Executive Summary',
            url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=89307cc6-2f54-432e-b917-3727b4f3423c&reportObjectId=11cb5041-aa66-4213-aa8c-2a3ac897bb5b&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=95af2d22bdb74ad16203&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
            description: 'Provides a deep dive into the renewal book, including key renewal KPIs, upcoming renewals, delayed renewals, account-level renewal detail, and deal-size views.'
          },
          {
            name: 'Win Loss',
            url: '',
            description: 'Upcoming dashboard focused on win/loss insights to help users understand deal outcomes, performance patterns, and areas for commercial improvement.'
          },
          {
            name: 'Refresh over Refresh',
            url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=89307cc6-2f54-432e-b917-3727b4f3423c&reportObjectId=16e751a0-8297-44d9-9151-0ac7dd5cf09b&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=5e70922a0a7913e1b973&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
            description: 'Provides real-time insights into sales, pipeline, renewals, cancellations, and year-over-year performance across business lines, products, and regions. The dashboard helps users monitor performance, identify risks and opportunities, and support strategic decision-making.'
          }
        ]
      },
      {
        name: 'MI Deep Dive',
        url: 'https://app.powerbi.com/groups/me/apps/077d1cc8-b2b3-4d85-a473-2996e08981b8/reports/a688a43a-b442-473e-83e5-90fef5ace296/89e5e97f60da861de4b4?ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&experience=power-bi',
        tags: ['Revenue Leaders'],
        description: 'Provides real-time insights into sales, pipeline, renewals, cancellations, and year-over-year performance across business lines, products, and regions. The dashboard supports performance monitoring, risk and opportunity identification, and strategic decision-making.'
      },
      {
        name: 'Synergy Tracker',
        url: 'https://app.powerbi.com/groups/bff080e0-1a9e-4536-a898-8bb1e93c5062/reports/0e9a4f37-7ec0-4dce-87e5-eacfdb836bd7/ReportSection?experience=power-bi',
        tags: ['Revenue Leaders'],
        description: 'Tracks revenue generated through cross business synergies and referral driven sales across MI, FS, and other business lines.'
      },
    ]
  },
  {
    id: 'persona-insights-frontline-hub',
    title: 'Persona Insights / Frontline Hub',
    tags: ['Sales Specialist', 'Account Management'],
    dashboards: [
      {
        name: 'DAM',
        url: '',
        tags: ['Account Management'],
        description: 'DAM Dashboards.',
        isHeading: true,
        subDashboards: [
          {
            name: 'DAM Dashboard',
            url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=1352f087-f65a-4a5e-9a93-2d4f904359fb&reportObjectId=8f4fa6a2-9b96-4f0b-a33d-3effb9055efe&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=2c5fcca1d1de1bf6c388&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
            description: 'Persona dashboard for Divisional Account Managers, providing performance tracking, pipeline visibility, and account-level insights to support portfolio management and execution.'
          },
          {
            name: 'Renewal Management Dashboard',
            url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=1352f087-f65a-4a5e-9a93-2d4f904359fb&reportObjectId=b0ee2ef4-ebfd-49d1-8c92-d469a3bef925&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=e61edf2c50a540c360bb&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
            description: 'Action-oriented dashboard for managing upcoming, delayed, at-risk, and behind-schedule renewals. It helps teams prioritize renewal actions, monitor renewal book health, and focus attention on accounts requiring follow-up.'
          }
        ]
      },
      {
        name: 'Sales Specialist',
        url: '',
        tags: ['Sales Specialist'],
        description: 'Sales Specialist dashboards.',
        isHeading: true,
        subDashboards: [
          {
            name: 'Sales Specialist Dashboard',
            url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=1352f087-f65a-4a5e-9a93-2d4f904359fb&reportObjectId=897ddf3b-90f7-4bad-b973-d14c2788c27c&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=daa5a837c792e48faad2&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
            description: 'Persona dashboard for Sales Specialists, providing visibility into performance metrics, pipeline status, and sales activity tracking.'
          },
          {
            name: 'New Sales Management Dashboard',
            url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=1352f087-f65a-4a5e-9a93-2d4f904359fb&reportObjectId=d0f0e3f4-f269-4293-a8d5-c92608d710c9&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=e61edf2c50a540c360bb&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
            description: 'Action-oriented dashboard for Sales Specialists to track pipeline opportunities, identify sales priorities, and support new sales execution.'
          }
        ]
      },
      {
        name: 'ES-Hybrid Dashboard',
        url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=1352f087-f65a-4a5e-9a93-2d4f904359fb&reportObjectId=173073c1-4eab-4ef1-b192-e25eeb35ba89&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=0c02b052465dbc94b79c&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
        tags: ['Sales Specialist', 'Account Management'],
        description: 'Provides ES sales representatives with performance tracking that combines new sales and renewals, supporting visibility across their hybrid coverage model.'
      },
      {
        name: 'Primary AM Dashboard',
        url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=1352f087-f65a-4a5e-9a93-2d4f904359fb&reportObjectId=bb5784f4-847f-4ee4-a2ff-9017848a10e5&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=2c5fcca1d1de1bf6c388&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
        tags: ['Account Management'],
        description: 'Persona dashboard for Primary Account Managers covering performance, accounts, pipeline, renewals and key activity indicators.'
      },
      {
        name: 'Rep Scorecard',
        url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=1352f087-f65a-4a5e-9a93-2d4f904359fb&reportObjectId=af6bec40-8647-411b-855b-fbb0f310b1a1&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=7ac20f4d5e37c9330334&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
        tags: ['Sales Specialist', 'Account Management'],
        description: 'Productivity tracking tool for frontline users. It provides a comprehensive overview of sales performance and highlights defined KPIs to support performance discussions and execution tracking.'
      }
    ]
  },
  {
    id: 'growth-hub',
    title: 'Growth Hub',
    tags: ['Account Management', 'Sales Specialist', 'Prospecting'],
    dashboards: [
      {
        name: 'Customer Acquisition',
        url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=f1997a86-5c5d-4b4a-9220-2c2dbf7b2ed9&reportObjectId=3eb79c0f-0fb4-4e85-94f9-520df9b30c9a&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=9ff5e9d0b34e46e529c4&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
        tags: ['Account Management', 'Sales Specialist', 'Prospecting'],
        description: 'Supports identification of whitespace and greenfield opportunities by cross-referencing Capital IQ Pro data against existing customers and the Book of Business. It acts as a new-logo engine focused on surfacing high-fit opportunities and accelerating pipeline creation.',
        subDashboards: [
          {
            name: 'New Logo',
            url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=f1997a86-5c5d-4b4a-9220-2c2dbf7b2ed9&reportObjectId=3eb79c0f-0fb4-4e85-94f9-520df9b30c9a&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=9ff5e9d0b34e46e529c4&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
            description: 'Identifies potential new-logo opportunities using customer and market data to support targeted acquisition efforts.'
          },
          {
            name: 'New Logo Public',
            url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=f1997a86-5c5d-4b4a-9220-2c2dbf7b2ed9&reportObjectId=42e1fd0a-067b-4033-a1af-d9a14b8be669&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=df4f105a0713ee0e08da&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
            description: 'Supports public-company new-logo identification by surfacing relevant whitespace and acquisition opportunities.'
          },
          {
            name: 'New Logo Private',
            url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=f1997a86-5c5d-4b4a-9220-2c2dbf7b2ed9&reportObjectId=26b9f24e-4850-418b-b566-d97377555d1a&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=05976a71a592a94c0496&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
            description: 'Supports private-company new-logo identification by surfacing relevant whitespace and acquisition opportunities.'
          }
        ]
      },
      {
        name: 'Account Growth Navigator',
        url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=f1997a86-5c5d-4b4a-9220-2c2dbf7b2ed9&reportObjectId=27e829da-517f-46f9-92d7-315f4fdb50a2&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=911ab5b70d5d1a458a21&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
        tags: ['Account Management', 'Sales Specialist', 'Prospecting'],
        description: 'Provides a comprehensive view of an Account Manager\'s portfolio, including spend distribution across products. It also offers tailored product recommendations and identifies opportunities to support business expansion.'
      },
      {
        name: 'Persona Gap Analysis',
        url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=f1997a86-5c5d-4b4a-9220-2c2dbf7b2ed9&reportObjectId=a05eb89d-18e1-42d1-8631-3f9087a8faf8&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=6d0cf7440013c976e2b5&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
        tags: ['Account Management', 'Sales Specialist', 'Prospecting'],
        description: 'Helps Account Managers identify cross-sell and upsell opportunities by showing persona-aligned product gaps and product penetration for a selected client or segment.'
      },
      {
        name: 'Prospecting Solutions',
        url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=f1997a86-5c5d-4b4a-9220-2c2dbf7b2ed9&reportObjectId=86aa6130-c255-40e9-8ea1-bd4a3f0f28ef&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=048d4b466a1960dd8a04&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
        tags: ['Account Management', 'Sales Specialist', 'Prospecting'],
        description: 'Dynamic dashboard suite that identifies potential customers who have not yet purchased specific products, based on existing purchase behavior. It supports targeted prospecting and sales outreach.',
        subDashboards: [
          {
            name: 'Product Affinity Analyzer',
            url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=f1997a86-5c5d-4b4a-9220-2c2dbf7b2ed9&reportObjectId=86aa6130-c255-40e9-8ea1-bd4a3f0f28ef&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=048d4b466a1960dd8a04&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
            description: 'Identifies product affinity patterns to help users understand which products are commonly purchased together and where additional opportunities may exist.'
          },
          {
            name: 'Automated Prospecting List',
            url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=f1997a86-5c5d-4b4a-9220-2c2dbf7b2ed9&reportObjectId=86aa6130-c255-40e9-8ea1-bd4a3f0f28ef&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=ReportSection7df534e0c5568cd00009&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
            description: 'Generates prospecting lists to help users prioritize outreach based on potential product fit and opportunity signals.'
          },
          {
            name: 'Account Identifier',
            url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=f1997a86-5c5d-4b4a-9220-2c2dbf7b2ed9&reportObjectId=86aa6130-c255-40e9-8ea1-bd4a3f0f28ef&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=b47b50b269e02b74093a&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
            description: 'Helps identify relevant accounts for prospecting motions and opportunity development.'
          }
        ]
      }
    ]
  },
  {
    id: 'customer-intelligence',
    title: 'Customer Intelligence',
    tags: ['Account Management', 'Customer Success'],
    dashboards: [
      {
        name: 'Account Intel',
        url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=c23bfa72-af38-4095-8e95-07d5e3234bcb&reportObjectId=c4834996-2692-4dae-83d3-5c04b761cf55&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=ebaab9dc7cb08e571e50&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
        tags: ['Account Management', 'Customer Success'],
        description: 'Unified 360° customer view combining commercial performance, contracts, usage analytics, and engagement insights. It enables data-driven decisions for retention, expansion, risk mitigation, and account planning.'
      },
      {
        name: 'Customer Peer Comparison',
        url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=c23bfa72-af38-4095-8e95-07d5e3234bcb&reportObjectId=44b01b18-eac5-42ed-acea-b2f017d36813&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=bc78e8c8d3b188ae5709&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
        tags: ['Account Management', 'Customer Success'],
        description: 'Customer peer comparison view tailored for Account Managers. It enables users to benchmark accounts against industry peers and identify relative performance, opportunity, or engagement patterns.'
      },
      {
        name: 'Account Health Screener',
        url: 'https://app.powerbi.com/Redirect?action=OpenReport&appId=c23bfa72-af38-4095-8e95-07d5e3234bcb&reportObjectId=30664541-7d3a-439d-baea-182a11cfa8e5&ctid=8f3e36ea-8039-4b40-81a7-7dc0599e8645&reportPage=9ae446e91e00ad812ed5&pbi_source=appShareLink&portalSessionId=554538b3-908c-420b-a282-9eb59b52fad9',
        tags: ['Account Management', 'Customer Success'],
        description: 'Identifies accounts meeting key health criteria at scale. It provides a unified view of customer accounts by integrating usage data from multiple sources to support account review, risk identification, and prioritization.'
      }
    ]
  }
].sort((firstTile, secondTile) => dashboardTileOrder.indexOf(firstTile.id) - dashboardTileOrder.indexOf(secondTile.id));